import { createAction } from "redux-actions";
import { GET_ELECTRIC_COMPANIES_CORE } from "../constants";
import { feathersCreateData } from "../services";

export const getElectricCompaniesCore = createAction(GET_ELECTRIC_COMPANIES_CORE, () => feathersCreateData('core-server', {
    service: 'COLLECTIONS',
    func: 'GET_ELECTRIC_COMPANIES'
})())